import {ValueObject} from '@s-ui/domain'

import {ProductTrackingDataValueObject} from './ProductTrackingDataValueObject.js'

export class ListProductsTrackingDataValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new ListProductsTrackingDataValueObject({
      value: value.map(ProductTrackingDataValueObject.createFromPrimitives)
    })
  }

  get value() {
    return this.#value.map(product => product.value)
  }
}
